import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  body: {
    padding: "8px 16px 16px 16px",
    overflowY: "auto",
  },
}));

/**
 * Main content area of the dialog. Place your form fields, info sections,
 * or any other content here.
 *
 * @param {string} className - Additional class name
 * @param {object} style     - Additional inline styles
 */
const DialogBody = ({ className = "", style = {}, children, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.body} ${className}`} style={style} {...rest}>
      {children}
    </div>
  );
};

export default DialogBody;
